import React from "react";

import styled from "styled-components";

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 80;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(15, 23, 42, 0.35);
`;

const Panel = styled.div`
    width: min(440px, calc(100vw - 32px));
    padding: 18px;
    border: 1px solid #d4dee8;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 20px 36px rgba(15, 23, 42, 0.2);
`;

const Title = styled.div`
    color: #1f3348;
    font-size: 16px;
    font-weight: 800;
`;

const Message = styled.div`
    margin-top: 8px;
    color: #42576b;
    font-size: 13px;
    line-height: 1.5;
`;

const ProgressTrack = styled.div`
    height: 8px;
    margin-top: 14px;
    overflow: hidden;
    border-radius: 999px;
    background: #e5edf5;
`;

const ProgressBar = styled.div`
    width: ${(props) => `${props.$progress}%`};
    height: 100%;
    border-radius: inherit;
    background: #138a6d;
    transition: width 180ms ease-out;
`;

export function isTemplateGenerationJob(job) {
    return job?.job_type === "template_generation";
}

export function isTemplateGenerationInProgress(job) {
    return isTemplateGenerationJob(job) && ["queued", "running"].includes(job.status);
}

export function isTemplateGenerationFailed(job) {
    return isTemplateGenerationJob(job) && job.status === "failed";
}

export default function ManuscriptTemplateOverlay({ job }) {
    const inProgress = isTemplateGenerationInProgress(job);
    const failed = isTemplateGenerationFailed(job);

    if (!inProgress && !failed) {
        return null;
    }

    return (
        <Overlay>
            <Panel
                role="dialog"
                aria-label="LaTeX 템플릿 생성 상태"
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                <Title>{failed ? "LaTeX 템플릿 생성 실패" : "LaTeX 템플릿 생성 중"}</Title>
                <Message>
                    {job?.message || (failed ? "템플릿 생성 중 오류가 발생했습니다." : "PDF 양식을 분석하고 있습니다.")}
                </Message>
                {!failed ? (
                    <ProgressTrack>
                        <ProgressBar $progress={job?.progress || 0} />
                    </ProgressTrack>
                ) : null}
            </Panel>
        </Overlay>
    );
}
